import { useCallback, useMemo } from 'react';

export function useTelegram() {
  const tg = typeof window !== 'undefined' ? window.Telegram?.WebApp : null;
  const user = tg?.initDataUnsafe?.user || null;

  const hapticFeedback = useCallback((type = 'light') => {
    try {
      if (tg?.HapticFeedback) {
        if (type === 'light') tg.HapticFeedback.impactOccurred('light');
        else if (type === 'medium') tg.HapticFeedback.impactOccurred('medium');
        else if (type === 'heavy') tg.HapticFeedback.impactOccurred('heavy');
      }
    } catch (e) {}
  }, [tg]);

  return useMemo(() => ({ tg, user, hapticFeedback }), [tg, user, hapticFeedback]);
}
